(function ($) {
	$(function () {
		if ($('.media-wrapper').length > 0) {
			$('.media-wrapper').each(function () {
				const _wrapper = this;
				$(_wrapper)
					.find('[id*="ae-media-"]')
					.on('click tap', function () {
						const trigger = $(this);
						clickHandlerfunction(trigger);
					});
			});
		}
	});

	var clickHandlerfunction = function (_trigger) {
		_trigger.hide();
		if (_trigger.attr('data-media') == 'youtubelive') {
			_trigger
				.siblings('.media-layer')
				.show()
				.children('iframe')
				.attr(
					'src',
					'https://www.youtube.com/embed/live_stream?channel=' +
						_trigger.attr('data-source')
				);
		} else if (_trigger.attr('data-media') == 'youtube') {
			_trigger
				.siblings('.media-layer')
				.show()
				.children('iframe')
				.attr(
					'src',
					'https://www.youtube-nocookie.com/embed/' +
						_trigger.attr('data-source') +
						'&rel=0&showinfo=0&autoplay=1'
				);
		} else if (_trigger.attr('data-media') == 'vimeo') {
			_trigger
				.siblings('.media-layer')
				.show()
				.children('iframe')
				.attr(
					'src',
					'https://player.vimeo.com/video/' +
						_trigger.attr('data-source') +
						'?dnt=1&autoplay=1&color=ffffff'
				);
		} else {
			_trigger
				.siblings('.media-layer')
				.show()
				.children('iframe')
				.attr('src', _trigger.attr('data-source'));
		}
	};

	window.clickHandlerfunction = clickHandlerfunction;
})(jQuery);
